(() => {
 'use strict';
 if (window.__otherdayLandingLoaded) return;
 window.__otherdayLandingLoaded = true;
 const root = document;
 const isPreview = document.body.dataset.mode === 'preview';
 const toggle = root.querySelector('.menu-toggle');
 const menu = root.querySelector('.mobile-menu');
 toggle?.addEventListener('click', () => {
   const expanded = toggle.getAttribute('aria-expanded') !== 'true';
   toggle.setAttribute('aria-expanded', String(expanded));
   toggle.setAttribute('aria-label', expanded ? 'Close navigation' : 'Open navigation');
   menu.hidden = !expanded;
 });
 menu?.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
   menu.hidden = true; toggle.setAttribute('aria-expanded', 'false');
   toggle.setAttribute('aria-label', 'Open navigation');
 }));
 root.addEventListener('keydown', e => { if (e.key === 'Escape' && menu && !menu.hidden) { menu.hidden = true;toggle.setAttribute('aria-expanded','false');toggle.focus(); } });
 root.querySelectorAll('.gallery-thumb').forEach(button => button.addEventListener('click', () => {
   const source = button.querySelector('img');
   const hero = root.querySelector('.hero-image');
   if (!hero || !source) return;
   hero.src = source.dataset.large || source.src;
   hero.srcset = source.dataset.largeSrcset || source.srcset;
   hero.alt = source.alt;
   root.querySelectorAll('.gallery-thumb').forEach(b => {
     b.classList.toggle('is-active', b === button);
     b.setAttribute('aria-pressed', String(b === button));
   });
 }));
 const showDialog = dialog => { if (dialog && !dialog.open) dialog.showModal(); };
 root.querySelectorAll('[data-open-privacy]').forEach(button => button.addEventListener('click', () => showDialog(root.querySelector('.privacy-dialog'))));
 root.querySelectorAll('[data-open-cookies]').forEach(button => button.addEventListener('click', () => {
   if (!isPreview && window.privacyBanner?.showPreferences) window.privacyBanner.showPreferences();
   else showDialog(root.querySelector('.cookies-dialog'));
 }));
 root.querySelectorAll('dialog').forEach(dialog => {
   dialog.querySelectorAll('[data-close-dialog]').forEach(button => button.addEventListener('click', () => dialog.close()));
   dialog.addEventListener('click', e => { if (e.target === dialog) { const r=dialog.getBoundingClientRect();if (e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom) dialog.close(); } });
 });
 const welcome = root.querySelector('.welcome-dialog');
 if(welcome){
   const tabs = root.querySelectorAll('[data-open-welcome]');
   tabs.forEach(tab=>tab.hidden=false);
   const storageKey = 'otherday-welcome-seen';
   const hasResult = !!welcome.querySelector('[data-welcome-success],[data-welcome-error]');
   let seen = false, ready = false, timer;
   const offer = root.querySelector('.hero-offer');
   try{seen = sessionStorage.getItem(storageKey) === '1';}catch{}
   const remember = () => {seen = true;try{sessionStorage.setItem(storageKey,'1');}catch{}};
   const bannerVisible = () => [...root.querySelectorAll('#shopify-pc__banner,#shopify-pc__prefs')].some(el => el.getClientRects().length > 0);
   const openWelcome = () => {
     if(root.querySelector('dialog[open]') || bannerVisible())return false;
     welcome.showModal();remember();return true;
   };
   const attempt = () => {
     const offerPassed = offer && offer.getBoundingClientRect().bottom < 0;
     if(seen || !ready || !offerPassed || root.visibilityState !== 'visible')return;
     if(root.activeElement?.matches('input,select,textarea,button') || root.querySelector('.purchase-form[aria-busy="true"]'))return;
     if(openWelcome()){clearTimeout(timer);}
     else{clearTimeout(timer);timer=setTimeout(attempt,3000);}
   };
   tabs.forEach(tab=>tab.addEventListener('click',openWelcome));
   welcome.addEventListener('close',remember);
   welcome.querySelector('form')?.addEventListener('submit',event=>{
     if(!event.target.reportValidity())return;
     remember();event.target.setAttribute('aria-busy','true');
     const submit=event.target.querySelector('[type="submit"]');if(submit)submit.disabled=true;
   });
   root.addEventListener('scroll',attempt,{passive:true});
   root.addEventListener('visibilitychange',attempt);
   if(hasResult){welcome.showModal();remember();}
   else if(!seen)timer=setTimeout(()=>{ready=true;attempt();},60000);
 }
 const sticky=root.querySelector('.mobile-sticky');
 const join=root.querySelector('.hero-offer');
 const final=root.querySelector('.final-section');
 if(sticky && join && final && 'IntersectionObserver' in window){
   let joinVisible=true,joinPassed=false,finalVisible=false;
   const update=()=>{sticky.hidden=!joinPassed||joinVisible||finalVisible;};
   const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.target===join){joinVisible=entry.isIntersecting;joinPassed=entry.boundingClientRect.bottom<0;}else finalVisible=entry.isIntersecting;});update();},{threshold:0});
   observer.observe(join);observer.observe(final);
 }
 const cartDialog = root.querySelector('.cart-dialog');
 const cartItems = root.querySelector('.cart-items');
 const cartMessage = root.querySelector('.cart-message');
 const commerceForm = root.querySelector('[data-commerce-form]');
 const cartMode = cartDialog?.dataset.cartMode || 'demo';
 const cartRoot = document.body.dataset.shopRoot || '/';
 let basket = {items:[],item_count:0,total_price:0,currency:'GBP'};
 try{if(cartMode!=='live'){const saved=Number(sessionStorage.getItem('otherday-demo-quantity'));if(Number.isInteger(saved)&&saved>0&&saved<=10)basket={items:[{key:'otherday-demo',product_title:'Otherday Iron Gel',title:'Otherday Iron Gel',price:2799,quantity:saved,line_price:2799*saved,final_line_price:2799*saved,image:'assets/otherday-product-480.webp'}],item_count:saved,total_price:2799*saved,currency:'GBP'};}}catch{}
 let cartBusy = false;
 const money = (cents,currency='GBP') => new Intl.NumberFormat('en-GB',{style:'currency',currency}).format(cents/100);
 const setMessage = message => {if(cartMessage)cartMessage.textContent=message;};
 const make = (tag,className,text) => {const el=root.createElement(tag);if(className)el.className=className;if(text!==undefined)el.textContent=text;return el;};
 const setActionLabel = (button, label, withArrow = false) => {
   button.replaceChildren(root.createTextNode(label));
   if (!withArrow) return;
   const svg = root.createElementNS('http://www.w3.org/2000/svg', 'svg');
   for (const [key, value] of Object.entries({class:'od-arrow',viewBox:'0 0 24 24',fill:'none',stroke:'currentColor','stroke-width':'1.5','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'})) svg.setAttribute(key, value);
   const path = root.createElementNS('http://www.w3.org/2000/svg', 'path');
   path.setAttribute('d', 'M5 12h14m-6-6 6 6-6 6');
   svg.append(path);button.append(svg);
 };
 const setBusy = busy => {
   cartBusy=busy;
   root.querySelectorAll('.cart-items [data-cart-change],.cart-items [data-cart-remove]').forEach(el=>el.disabled=busy);
   commerceForm?.querySelectorAll('button,input,select').forEach(el=>el.disabled=busy);
   if(commerceForm)commerceForm.setAttribute('aria-busy',String(busy));
   commerceForm?.querySelectorAll('[type=submit]').forEach(submit=>{
     const selected=commerceForm.querySelector('select[name=id]')?.selectedOptions?.[0];
     const available=selected?selected.dataset.available!=='false':commerceForm.dataset.selectedAvailable!=='false';
     submit.disabled=busy||!available;
     setActionLabel(submit,busy?'Adding…':available?(submit.hasAttribute('data-buy-now')?'Buy now':'Add to cart'):'Unavailable',!busy&&available);
   });
   const checkout=cartDialog?.querySelector('.cart-checkout');
   if(checkout)checkout.setAttribute('aria-disabled',String(busy));
 };
 const renderBasket = () => {
   root.querySelectorAll('[data-demo-checkout-link]').forEach(link=>link.hidden=basket.item_count===0);
   root.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=String(basket.item_count));
   if(!cartItems)return;
   cartItems.replaceChildren();
   if(!basket.items.length)cartItems.append(make('p','cart-empty','A little room for Otherday.'));
   basket.items.forEach(item=>{
     const row=make('article',document.body.dataset.bagPage?'cart-item bag-line':'cart-item');
     const image=make('img');image.src=item.image || root.querySelector('.hero-image')?.src || '';image.alt=item.product_title || item.title;image.width=180;image.height=225;row.append(image);
     const content=make('div',document.body.dataset.bagPage?'bag-line-info':'');if(document.body.dataset.bagPage)content.append(make('p','eyebrow','14 GEL SACHETS'));content.append(make('h3','',item.product_title || item.title));
     if(item.variant_title && item.variant_title!=='Default Title')content.append(make('p','',item.variant_title));
     content.append(make('p','',money(item.final_line_price ?? item.line_price,basket.currency)));
     const controls=make('div','quantity-control');
     const label=item.product_title || item.title;
     for(const step of [-1,1]){
       if(step===1){const value=make('span','quantity-value',String(item.quantity));value.setAttribute('aria-label','Quantity: '+item.quantity);controls.append(value);}
       const button=make('button','',step===-1?'−':'+');button.type='button';button.dataset.cartChange=String(step);button.dataset.key=item.key;button.setAttribute('aria-label',(step===-1?'Decrease':'Increase')+' quantity of '+label);button.disabled=cartBusy;
       if(step===1 && cartMode!=='live' && item.quantity>=10)button.disabled=true;
       button.addEventListener('click',()=>changeItem(item.key,item.quantity+step));controls.append(button);
     }
     content.append(controls);
     const remove=make('button','cart-remove','Remove');remove.type='button';remove.dataset.cartRemove='';remove.disabled=cartBusy;remove.setAttribute('aria-label','Remove '+label);remove.addEventListener('click',()=>changeItem(item.key,0));content.append(remove);row.append(content);cartItems.append(row);
   });
   const footer=cartDialog?.querySelector('.cart-footer');if(footer)footer.hidden=!basket.items.length;
   const total=cartDialog?.querySelector('[data-cart-total]');if(total)total.textContent=money(basket.total_price,basket.currency);
   if(!cartDialog){root.querySelectorAll('[data-cart-total]').forEach(el=>el.textContent=money(basket.total_price,basket.currency));}
   if(cartMode!=='live'){try{sessionStorage.setItem('otherday-demo-quantity',String(basket.item_count));}catch{}}
   if(cartMode==='handoff'){const checkout=cartDialog?.querySelector('.cart-checkout');if(checkout)checkout.href=document.body.dataset.checkoutStore+'/cart/'+document.body.dataset.checkoutVariant+':'+basket.item_count;}
 };
 const recalculateDemo = () => {
   basket.item_count=basket.items.reduce((sum,item)=>sum+item.quantity,0);
   basket.items.forEach(item=>item.line_price=item.final_line_price=item.price*item.quantity);
   basket.total_price=basket.items.reduce((sum,item)=>sum+item.line_price,0);
 };
 const requestCart = async (endpoint,body) => {
   const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),12000);
   try{
     const response=await fetch(cartRoot+endpoint,{method:body?'POST':'GET',signal:controller.signal,headers:body?{'Content-Type':'application/json','Accept':'application/json'}:{'Accept':'application/json'},...(body?{body:JSON.stringify(body)}:{})});
     let result;try{result=await response.json();}catch{throw new Error('We couldn’t confirm that update. Open your bag before trying again.');}
     if(!response.ok)throw new Error(typeof result.description==='string'?result.description:'We couldn’t update your bag. Please try again.');
     return result;
   }catch(error){if(error.name==='AbortError'||error instanceof TypeError)throw new Error('We couldn’t confirm that update. Open your bag before trying again.');throw error;}
   finally{clearTimeout(timeout);}
 };
 const refreshBasket = async () => {basket=await requestCart('cart.js');renderBasket();};
 const openBasket = async () => {
   showDialog(cartDialog);setMessage('');
   if(cartMode!=='live'){renderBasket();return;}
   if(cartBusy)return;
   setBusy(true);setMessage('Loading your bag…');
   try{await refreshBasket();setMessage('');}catch{setMessage('We couldn’t load your bag. Close it and try again, or use the basket page.');}finally{setBusy(false);}
 };
 async function changeItem(key,quantity){
   if(cartBusy)return;
   setBusy(true);setMessage('');
   try{
     if(cartMode==='live'){basket=await requestCart('cart/change.js',{id:key,quantity});}
     else{basket.items=basket.items.flatMap(item=>item.key!==key?[item]:quantity>0?[{...item,quantity:Math.min(10,quantity)}]:[]);recalculateDemo();}
     renderBasket();setMessage(basket.items.length?'Bag updated.':'Your bag is empty.');
   }catch(error){setMessage(error.message);}
   finally{setBusy(false);}
 }
 root.querySelectorAll('[data-open-cart]').forEach(button=>button.addEventListener('click',openBasket));
 root.querySelectorAll('[data-close-cart]').forEach(link=>link.addEventListener('click',()=>cartDialog?.close()));
 commerceForm?.querySelectorAll('[data-quantity-step]').forEach(button=>button.addEventListener('click',()=>{
   const input=commerceForm.querySelector('[name=quantity]');const current=Number(input.value)||1;input.value=String(Math.max(1,Math.min(Number(input.max)||10,current+Number(button.dataset.quantityStep))));
 }));
 commerceForm?.querySelector('[name=id]')?.addEventListener('change',event=>{
   const option=event.target.selectedOptions?.[0];if(!option?.dataset.price)return;
   const price=Number(option.dataset.price);root.querySelectorAll('.product-price,.purchase-option [data-selected-price]').forEach(el=>el.textContent=money(price,commerceForm.dataset.currency||'GBP'));
   commerceForm.querySelectorAll('[type=submit]').forEach(submit=>{submit.disabled=option.dataset.available==='false';setActionLabel(submit,submit.disabled?'Unavailable':submit.hasAttribute('data-buy-now')?'Buy now':'Add to cart',!submit.disabled);});
 });
 commerceForm?.addEventListener('submit',async event=>{
   const mode=commerceForm.dataset.cartMode;
   if(mode==='closed')return;
   event.preventDefault();if(cartBusy || !commerceForm.reportValidity())return;
   const goToCheckout=event.submitter?.hasAttribute('data-buy-now');
   const quantity=Number(commerceForm.querySelector('[name=quantity]').value);
   if(!Number.isInteger(quantity)||quantity<1||quantity>10)return;
   const status=commerceForm.querySelector('.purchase-status');status.textContent='';setBusy(true);
   try{
     if(mode==='live'){
       const id=commerceForm.querySelector('[name=id]').value;
       await requestCart('cart/add.js',{items:[{id,quantity}]});
       if(goToCheckout){window.location.assign(cartRoot+'checkout');return;}
       try{await refreshBasket();setMessage('Added to your bag.');}catch{setMessage('Added to your bag. The bag total could not refresh; open the basket page to review it.');}
     }else{
       const existing=basket.items[0];if((existing?.quantity||0)+quantity>10)throw new Error('The preview basket allows up to 10. Adjust your bag quantity first.');
       if(existing)existing.quantity+=quantity;
       else basket.items=[{key:'otherday-demo',product_title:'Otherday Iron Gel',title:'Otherday Iron Gel',price:2799,quantity,image:root.querySelector('.hero-image')?.src}];
       recalculateDemo();renderBasket();setMessage(mode==='handoff'?'Added to your bag.':'Added to your preview bag. No payment has been taken.');
     }
     showDialog(cartDialog);status.textContent=mode==='live'||mode==='handoff'?'Added to your bag.':'Added to your preview bag.';
   }catch(error){status.textContent=error.message;}
   finally{setBusy(false);}
 });
 cartDialog?.querySelector('.cart-checkout')?.addEventListener('click',event=>{if(cartBusy)event.preventDefault();});
 if(cartMode!=='live')renderBasket();
 const demoCheckout = root.querySelector('[data-demo-checkout]');
 if(demoCheckout){
   const button=demoCheckout.querySelector('[data-complete-demo]');
   demoCheckout.querySelector('[data-demo-checkout-quantity]').textContent=String(basket.item_count);
   demoCheckout.querySelectorAll('[data-cart-total]').forEach(el=>el.textContent=money(basket.total_price));
   button.disabled=basket.item_count===0;
   if(!basket.item_count)demoCheckout.querySelector('[data-demo-checkout-note]').textContent='Your bag is empty. Add a box to try the checkout demo.';
   button.addEventListener('click',()=>{
     if(!basket.item_count)return;
     demoCheckout.querySelector('[data-demo-checkout-summary]').hidden=true;
     demoCheckout.querySelector('[data-demo-complete]').hidden=false;
     try{sessionStorage.removeItem('otherday-demo-quantity');}catch{}
     basket={items:[],item_count:0,total_price:0,currency:'GBP'};
   });
 }

})();
